import type { PayexThunkAction } from 'store/configureStore';

import { SET_CAPTCHA_RESPONSE } from '../../../constants';

export const setCaptchaResponse =
  (response: string): PayexThunkAction =>
  dispatch => {
    return dispatch({ type: SET_CAPTCHA_RESPONSE, payload: { response } });
  };
